﻿$.validator.addMethod("required", function (value, element, param) {
	// Check if dependency is met
	if (!this.depend(param, element)) {
		return false;
	}
	if (element.nodeName.toLowerCase() === "select") {
		// Could be an array for select-multiple or a string, both are fine this way
		var val = $(element).val().toString();
		return val && val.length > 0;
	}
	if (this.checkable(element)) {
		return this.getLength(value, element) > 0;
	}

	// Trim the value first to disallow just spaces.
	return $.trim(value).length > 0;
});
